/*
PURPOSE: The root route's errorElement — NotFound for every error, except a chunk-load failure,
which reloads the page once instead.
USE CASES:
- Unknown routes and uncaught render/loader errors (NotFound).
- A tab loaded from a previous build navigating to a route whose code that build no longer serves.
DOMAIN BOUNDARIES:
- Routing fallback only; the reload decision and its loop guard live in utils/chunkLoadRecovery.
DOCUMENTATION LINKS: ai_docs/development/environment_setup.md#what-a-deploy-does-to-a-visitor-mid-session
*/

import React, { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';
import NotFound from '../pages/public-supplementary/NotFound/NotFound';
import { recoverFromChunkLoadError } from '../utils/chunkLoadRecovery';

const RootErrorElement: React.FC = () => {
  const error = useRouteError();
  // Rendering nothing until the effect decides keeps a "page not found" from flashing up just
  // before the reload.
  const [showNotFound, setShowNotFound] = useState(false);

  useEffect(() => {
    if (!recoverFromChunkLoadError(error)) setShowNotFound(true);
  }, [error]);

  return showNotFound ? <NotFound /> : null;
};

export default RootErrorElement;
